<template>
  <div class="relative w-full h-auto md:w-1/2 rounded-xl bg-blue-900 px-2 m-0 mb-4 md:m-4 flex">
    <!-- Ribbon -->
    <div
      class="absolute -top-4 right-0"
      style="top: -7px; right: -6px"
    >
      <img
        src="/images/ribbon.png"
        alt="ribbon"
        style="height: 7rem"
      />
    </div>
    <!-- End Ribbon -->

    <div class="m-auto w-full md:max-w-xl">
      <!-- stats -->
      <div class="py-4 lg:py-8 px-4 lg:px-8 mb-2">
        <p class="mt-2 text-xl font-bold text-white">
          Trusted by over <span class="text-green-600">3,000 accounting firms</span>
        </p>
        <dl class="mt-10 col-span-2 grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2">
          <div
            v-for="feature in features"
            :key="feature.name"
          >
            <dt class="text-xl lg:text-3xl text-white font-bold lg:leading-7">
              {{ feature.name }}
            </dt>
            <dd class="mt-3 text-sm text-gray-400 tracking-tight">{{ feature.description }}</dd>
          </div>
        </dl>
      </div>
      <!-- End stats -->

      <!-- Testimonial -->
      <div class="sm:px-4 lg:px-6 pb-4 mt-6">
        <section class="lg:p-8 p-4 mb-2 rounded-lg testimonial-bg text-gray-200">
          <figure class="mx-auto max-w-2xl">
            <blockquote class="italic leading-6 tracking-tight sm:leading-6 lg:text-lg sm:text-sm">
              <p>
                Working with Financial Cents is helping us bring our firm to the next level! It helps us track all work
                being done in the office. All of that translates into the excellent customer service we strive for every
                day with our clients.
              </p>
            </blockquote>
            <figcaption class="mt-10 lg:flex justify-between">
              <div class="flex items-center gap-x-4">
                <img
                  class="h-10 w-10 rounded-full"
                  src="/images/nancy.png"
                  alt="Nancy Wilson"
                />
                <div class="text-xs leading-4">
                  <div class="font-semibold">Nancy Wilson</div>
                  <div class="mt-0.5">JNW Group</div>
                </div>
              </div>
              <div class="self-end ml-6 sm:ml-0 pb-2">
                <div class="flex gap-x-1 text-green-600">
                  <ion-icon
                    class="h-3 w-3 flex-none"
                    aria-hidden="true"
                    name="star"
                  ></ion-icon>
                  <ion-icon
                    class="h-3 w-3 flex-none"
                    aria-hidden="true"
                    name="star"
                  ></ion-icon>
                  <ion-icon
                    class="h-3 w-3 flex-none"
                    aria-hidden="true"
                    name="star"
                  ></ion-icon>
                  <ion-icon
                    class="h-3 w-3 flex-none"
                    aria-hidden="true"
                    name="star"
                  ></ion-icon>
                  <ion-icon
                    class="h-3 w-3 flex-none"
                    aria-hidden="true"
                    name="star"
                  ></ion-icon>
                </div>
              </div>
            </figcaption>
          </figure>
        </section>
      </div>
    </div>
    <!-- End Testimonial -->
  </div>
</template>

<script>
export default {
  name: "RegisterInfo",

  data() {
    return {
      features: [
        {
          name: "97%",
          description: "Of firms improve visibility",
        },
        {
          name: "14 hours",
          description: "Saved per employee each week",
        },
        {
          name: "3 hours",
          description: "Is all it takes to implement Financial Cents",
        },
        {
          name: "95%",
          description: "Of customers recommend Financial Cents",
        },
      ],
    }
  },
}
</script>
<style>
.testimonial-bg {
  background-color: #042440;
}
</style>
